/**
 * Shared, dependency-free metric-bar derivation for the investigation dashboard.
 *
 * Group E (platform-data-fixes): the top metric bar MUST derive from the SAME
 * `filteredComplaints` that feed the Kanban columns — so it stays consistent with
 * the columns and reacts to the client filter — and must NOT carry the removed
 * "Tempo Médio" / avg_resolution_time SLA (no hardcoded 5d / 5.2d).
 *
 * The returned object's keys are EXACTLY { total, investigating, resolved,
 * resolutionRate } — there is no avg_resolution_time / tempo-médio field.
 *
 * Dual module shape: authored as ESM `export const` for the CRA/webpack build,
 * with a trailing CommonJS `module.exports` guard so Node's test runner (which
 * uses `require`) can validate the REAL logic in backend/test/bug-exploration.test.js.
 */

/**
 * Derive the metric bar from the filtered complaint set (same source as the Kanban).
 * @param {Array<{status?: string}>} filteredComplaints
 * @returns {{ total: number, investigating: number, resolved: number, resolutionRate: number }}
 */
export const deriveMetricBar = (filteredComplaints) => {
  const rows = Array.isArray(filteredComplaints) ? filteredComplaints : [];
  const total = rows.length;
  const investigating = rows.filter((c) => c && c.status === 'investigating').length;
  const resolved = rows.filter((c) => c && c.status === 'resolved').length;
  const resolutionRate = total > 0 ? Math.round((resolved / total) * 100) : 0;
  return { total, investigating, resolved, resolutionRate };
};

// CommonJS fallback so Node's test runner (require) can validate the real logic.
// CRA/webpack tolerates this trailing guard; the ESM export above drives the build.
if (typeof module !== 'undefined' && module.exports) {
  module.exports = { deriveMetricBar };
}
